import PageSeo from '@/seo/PageSeo';
import Biomarkers from '../components/Biomarkers/Biomarkers';

export default function BiomarkersPage() {
  return (
    <>
      <PageSeo
        title="Biomarker Discovery Database | DISGENET"
        description="Explore genomic and proteomic biomarkers from clinical trials, linked to DISGENET gene-disease associations."
        path="/biomarkers"
      />
      <Biomarkers />
    </>
  );
}
